import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { CustomTable, Text , useText} from '@src/components';
import { moneyFormat } from '@src/utils/utils';
import PO from '@src/assets/icons/ticketcar/4.svg';
import TOTAL from '@src/assets/icons/ticketcar/41.svg';
import BP from '@src/assets/icons/ticketcar/42.svg';
import '@src/styles/addNewCar/addCarOrderSummary.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';

const DATE_FORMAT = 'DD/MM/YYYY HH:mm';

const getIconComponent = (providerType) => {
  switch (providerType) {
    case 4:
      return PO;
    case 41:
      return TOTAL;
    case 42:
      return BP;
    default:
      return null;
  }
};

const VehicleFuelHistory = ({ vehicleFuelHistories, vehicleManagmentItem, historyPagination, setHistoryPagination, fetchVehicleFuelHistories }) => {
  const isMobil = useMediaQuery({ query: '(max-width: 999px)' });
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: isMobil ? 20 : 40,
      height: 50,
    },
    {
      title: <Text t={useText('orderDate')} />,
      dataIndex: 'salesDate',
      key: 'salesDate',
      align: 'left',
      sorter: true,
      width: 90,
      height: 50,
      render: (salesDate) => {
        const date = dayjs(salesDate, DATE_FORMAT);
        return (
          <span style={{ fontFamily: 'UbuntuMedium', fontWeight: 'bold', color: '#3f4957' }}>
            {date.isValid() ? date.format('DD.MM.YYYY') : 'N/A'}
          </span>
        );
      },
    },
    {
      title: <Text t="time" />,
      dataIndex: 'salesDate',
      key: 'salesDate',
      align: 'left',
      width: isMobil ? 80 : 90,
      height: 50,
      render: (salesDate) => {
        const time = dayjs(salesDate, DATE_FORMAT);
        return time.isValid() ? time.format('HH:mm') : 'N/A';
      },
    },
    {
      title: <Text t="branch" />,
      dataIndex: 'stationName',
      key: 'stationName',
      align: 'left',
      width: isMobil ? 80 : 90,
      height: 50,
    },
    {
      title: <Text t="provider2" />,
      dataIndex: 'provider',
      key: 'provider',
      align: 'left',
      width: isMobil ? 86 : 90,
      height: 50,
      render: (_, record) => {
        const vouId = record.providerType;
        const IconComponent = getIconComponent(vouId);

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {IconComponent && (
              <img
                src={IconComponent}
                alt={record.provider}
                style={{ width: 24, height: 24, marginRight: 8 }}
              />
            )}
            <p style={{ marginTop: 15 }}>{record.provider}</p>
          </div>
        );
      },
    },
    {
      title: <Text t="devices" />,
      dataIndex: 'deviceTypeLabel',
      key: 'deviceTypeLabel',
      align: 'left',
      width: 90,
      height: 50,
    },
    {
      title: <Text t="quantity" />,
      dataIndex: 'amount',
      key: 'amount',
      align: 'left',
      width: 70,
      height: 50,
      render: (amount) => `${moneyFormat(amount)}₺`,
    },
  ];

  return (
    <div data-testid="vehicle-fuel-histories-id" style={{ marginTop: '24px' }}>
      <div className="add-new-car-order-summary">
        <CustomTable
          dataSource={vehicleFuelHistories}
          columns={columns}
          rowKey={(record) => `vehicle-fuel-car-histories-list-${record?.id}`}
          pagination={{
            total: historyPagination?.totalItems,
            pageSize: historyPagination?.pageSize,
            current: historyPagination?.currentPage,
            onChange: (pageNumber, pageSize) => fetchVehicleFuelHistories(pageNumber, pageSize),
          }}
        />
      </div>
    </div>
  );
};

VehicleFuelHistory.propTypes = {
  vehicleFuelHistories: PropTypes.arrayOf(PropTypes.object),
  vehicleManagmentItem: PropTypes.object,
  historyPagination: PropTypes.shape({
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    totalItems: PropTypes.number,
  }),
  setHistoryPagination: PropTypes.func,
  fetchVehicleFuelHistories: PropTypes.func,
};

export default VehicleFuelHistory;
